import { DefaultOptionType } from 'rc-select/lib/Select';
import { ReactNode } from 'react';

const removeDiacritics = (text: string): string => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export interface SearchableSelectOptionType extends DefaultOptionType {
  searchableString: string;
}

/**
 * Convert values to text.
 * Complex ReactNodes (JSX, objects) are ignored.
 */
const toSearchableText = (value: ReactNode): string => {
  if (value === null) return '';

  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    return value
      .map(v =>
        typeof v === 'string' ||
        typeof v === 'number' ||
        typeof v === 'boolean' ||
        typeof v === 'bigint'
          ? String(v)
          : '',
      )
      .filter(Boolean)
      .join(' ');
  }

  // JSX.Element, ReactElement, object → ignore
  return '';
};

export const selectFilterHandler = (
  input: string,
  option?: DefaultOptionType,
  includeValue: boolean = true,
  diacritics: boolean = true,
): boolean => {
  let searchFor = input.toLowerCase();
  let optionValue = toSearchableText(option?.value).toLowerCase();
  let optionLabel = toSearchableText(option?.label).toLowerCase();

  if (!diacritics) {
    searchFor = removeDiacritics(searchFor);
    optionValue = removeDiacritics(optionValue);
    optionLabel = removeDiacritics(optionLabel);
  }

  let inSearchableString = false;
  if (option && 'searchableString' in option && typeof option.searchableString === 'string') {
    let searchableString = option.searchableString.toLowerCase();
    if (!diacritics) {
      searchableString = removeDiacritics(searchableString);
    }
    inSearchableString = searchableString.includes(searchFor);
  }

  return (
    (includeValue && optionValue.includes(searchFor)) ||
    optionLabel.includes(searchFor) ||
    inSearchableString
  );
};
